import Vue from 'vue'
import Vuex from 'vuex'
import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules'
import createMutationsSharer from 'vuex-shared-mutations'

import axios from 'axios'
import modules from './modules'

Vue.use(Vuex)
axios.defaults.baseURL = process.env.API_URL

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
  plugins: [createMutationsSharer({ predicate: ['auth/SET_CURRENT_TOKEN'] })],
})

export default store

// Automatically run the `init` action for every module,
// if one exists.
dispatchActionForAllModules('init')
